export default "__VITE_ASSET__CDrmNC_H__"